
export function Pagination({botCount, page, pageSize, setPage}) {
    const items = [];
    for(var i = 0; i < (botCount/pageSize) && i < 15; i++) {
      function man(i) {
        items.push(<div key={i} className={"text-xl font-bold " + (page !== i ? " text-pink-600 cursor-pointer " : "")}  onClick={async () => {
          //console.log("setting page to", i);
          await setPage(i);
        }}>{i + 1}</div>)
      };
      man(i);
    }
    return (
      <div className="py-10 m-auto w-1/2 flex flex-wrap justify-center gap-4">
          <div>Page</div>
          {items}
      </div>
    )
  }
  